import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Main from '@modules/main/Main';
import Login from '@modules/login/Login';
import { useWindowSize } from '@app/hooks/useWindowSize';
import { calculateWindowSize } from '@app/utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { setWindowSize } from '@app/store/reducers/ui';

import Portals from '@app/pages/portals/Portals';
import AdminDashboard from '@app/pages/admin/AdminDashboard';
import Profile from '@pages/profile/Profile';
import Users from '@app/pages/users/Users';
import AddUsers from '@app/pages/users/AddUsers';
import ManagePermission from '@app/pages/users/ManagePermission';
import ManageSites from '@app/pages/users/ManageSites';
import Permissions from '@app/pages/permissions/Permissions';
import AuditLog from './pages/audit-log/AuditLog';
import ViewAuditLog from './pages/audit-log/ViewAuditLog';
import ApiLog from './pages/api-log/ApiLog';
import ViewApiLog from './pages/api-log/ViewApiLog';
import Setting from '@pages/setting/Setting';

import PrivateRoute from './routes/PrivateRoute';
import PageNotFound from '@app/pages/Page404';
import PublicRoute from './routes/PublicRoute';

const App = () => {
  const windowSize = useWindowSize();
  const screenSize = useSelector((state: any) => state.ui.screenSize);
  const user = useSelector((state: any) => state.auth.currentUser);
  const [userData, setUserData] = useState(user);

  const dispatch = useDispatch();
  useEffect(() => {
    const size = calculateWindowSize(windowSize.width);
    if (screenSize !== size) {
      dispatch(setWindowSize(size));
    }
    if (user.role_id) {
      setUserData(user);
    }
  }, [windowSize, user]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>
        {userData.role_id == 1 &&
          <Route path="/" element={<PrivateRoute />}>
            <Route path="/" element={<Main />}>
              <Route path="/" element={<Portals />} />
              <Route path="/users" element={<Users />} />
              <Route path="/users/add" element={<AddUsers />} />
              <Route path="/users/edit/:id" element={<AddUsers />} />
              <Route path="/users/manage-sites/:id" element={<ManageSites />} />
              <Route path="/users/manage-permission/:user_id/:portal_id" element={<ManagePermission />} />
              <Route path="/permissions" element={<Permissions />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/audit-log" element={<AuditLog />} />
              <Route path="/audit-log/view/:id" element={<ViewAuditLog />} />
              <Route path="/api-log" element={<ApiLog />} />
              <Route path="/api-log/view/:id" element={<ViewApiLog />} />
              <Route path="/setting" element={<Setting />} />
              <Route path="*" element={<PageNotFound />} />
            </Route>
          </Route>
        }
        {userData.role_id != 1 &&
          <Route path="/" element={<PrivateRoute />}>
            <Route path="/" element={<Main />}>
              <Route path="/" element={<AdminDashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="*" element={<PageNotFound />} />
            </Route>
          </Route>
        }
      </Routes>

      <ToastContainer
        autoClose={3000}
        draggable={false}
        position="top-right"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnHover
      />
    </BrowserRouter>
  );
};

export default App;
